import ListAbsoluteI from '../types.ts';

const getProp: ListAbsoluteI['getProp'] = function () {
    return this.props.prop || 'key';
};

export default getProp;
